import FortuneForm from './FortuneForm';
import FortunePage1Header from './FortunePage1Header';

const FortunePage1 = () => {
  return (
    <section>
      <FortunePage1Header />
      <FortuneForm />
    </section>
  );
};

export default FortunePage1;
